module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.list.length > 0) ? _c('ul', {
    staticClass: "content"
  }, _vm._l((_vm.list), function(orow, index) {
    return _c('li', {
      key: index
    }, [(orow.order && orow.order.products && orow.order.products.length) ? _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "pic"
    }, [_c('img', {
      attrs: {
        "src": _vm.UPLOAD_DOMAIN + orow.order.products[0].thumbnail + '?x-oss-process=image/resize,w_120',
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text text-l flex-1"
    }, [_c('p', [_c('span', {
      staticClass: "title"
    }, [_vm._v("\n                                    " + _vm._s(orow.order.products[0].title)), (orow.order.products[0].specLabel) ? _c('span', [_vm._v("(" + _vm._s(orow.order.products[0].specLabel) + ")")]) : _vm._e(), (orow.order.products.length > 1) ? _c('span', [_vm._v("等")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "fr"
    }, [_vm._v("共" + _vm._s(_vm.totalCount(orow.order)) + "件")])])])])]) : _vm._e(), _vm._v(" "), _vm._l((orow.expressInfosData), function(info, index) {
      return _c('div', [_c('divider', [_vm._v(_vm._s(info.expTextName) + " " + _vm._s(info.mailNo))]), _vm._v(" "), (info.data) ? _c('timeline', _vm._l((info.data), function(row, index) {
        return _c('timeline-item', {
          key: index
        }, [_c('h4', {
          class: [index === 0 ? 'recent' : '']
        }, [_vm._v(_vm._s(row.context))]), _vm._v(" "), _c('p', {
          class: [index === 0 ? 'recent' : '']
        }, [_vm._v(_vm._s(row.time))])])
      })) : _vm._e()], 1)
    })], 2)
  })) : _c('load-more', {
    attrs: {
      "show-loading": false,
      "tip": '无物流中的订单',
      "background-color": "#fbf9fe"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cb8c08c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderList/Shipment.vue
// module id = 541
// module chunks = 0